import { REDUCE_TOOLTIP_INFO_ELEMENT } from '../../constants/actions/policy';

export function reduceTooltipInfoElement(payload) {
    return {
        type: REDUCE_TOOLTIP_INFO_ELEMENT,
        payload,
    };
}
